const rawDemoMode = (import.meta.env.VITE_DEMO_MODE as string | undefined)?.trim().toLowerCase()

export const isDemoMode = rawDemoMode === 'true' || rawDemoMode === '1'
